import * as React from 'react';
import { ApolloClient } from '@apollo/client';

export function useMultiQuery(
  client: ApolloClient<object>,
  queries: any[]
): [any[], boolean] {
  const [result, setResult] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    /*
    This hook is only rerun on changes to the query. If entries are added or
    modified in the cache this hook will not re-run and results will not be
    updated from local cache-writing! If we could rerun the queries (or just
    some) on updates to the cached queries, that would be be neat.
    */
    async function runQueries(): Promise<any> {
      setLoading(true);

      Promise.all(
        queries.map((query) => {
          return client.query(query);
        })
      ).then((results) => {
        setResult(results.map(({ data }) => data));
        setLoading(false);
      });
    }

    runQueries();
  }, [JSON.stringify(queries)]); // JSON.stringfify here is odd, but: https://github.com/facebook/react/issues/14476

  return [result, loading];
}

export function multiMutation(
  client: ApolloClient<object>,
  mutations: any[]
): Promise<any> {
  return Promise.all(
    mutations.map((mutation) => {
      return client.mutate(mutation);
    })
  );
}
